export const member = {
    buyMember: {
        memberCenter: '会员中心',
        notMember: '您当前还不是会员哦~',
        freeUser: '免费用户',
        unit: '￥',
        year: '年',
        basicMemberQuarter: '基础会员-季度',
        basicMemberQuarterTip:
            '免费代画2个户型、畅享所有VIP资源、无限次软装材质替换',
        basicMember: '基础会员-年度',
        basicMemberTip: '所有VIP资源包、无限次软装材质替换',
        seniorMember: '高级会员-年度',
        seniorMemberTip: '无限次复制方案、创建3D户型、探索AI灵感',
        renewalRule: '到期自动续费，可随时取消',
        memberTableTitle: '会员详细权益对比',
        coreValue: '核心价值',
        replicationScheme: '复制方案',
        num: '{num,number}个',
        unlimitedTimes: '不限',
        resourcePacks: '官方VIP资源包',
        uploadResource: '上传资源',
        customerAcquisition: '线下获客',
        softMaterialReplacement: '软装材质替换',
        apartment3DType: '3D户型',
        AIInspiration: 'AI灵感',
        readAgreement: '开通前请认真阅读',
        paymentMoney:
            '确认协议并开通支付&emsp;<span class="price">￥{money}</span>',
        expiryDate: '有效期至{date}',
        expirationDate: '已于{date}到期',
        immediateRenewal: '立即续费',
        buyMemberTip: '{date} 到期，购买后有效期将顺延',
        freehandMode: '手绘模式',
        num1: '{num,number}次',
        brush: '材质刷',
        manageSystem: '水电暖管综系统',
        sunlightAnalysis: '日照分析',
        export: '导出全屋漫游',
    },
};
